import React from 'react';
import { twMerge } from 'tailwind-merge';

interface LinkProps {
  className?: string;
  width?: number;
  height?: number;
}

const LinkIcon = function LinkIcon({
  className,
  width,
  height,
}: LinkProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 20"
    >
      <path className={twMerge('fill-transparent', className)} d="M12.8332 8.33463L9.1665 11.668" stroke="#F97171" strokeLinecap="round" strokeLinejoin="round" />
      <path className={twMerge('fill-transparent', className)} d="M14.6668 10.8346L16.2824 9.36593C17.628 8.14269 17.628 6.02658 16.2824 4.80334V4.80334C15.1064 3.73429 13.3105 3.73429 12.1346 4.80334L10.0835 6.66797M7.3335 9.16797L5.71792 10.6367C4.37235 11.8599 4.37235 13.976 5.71792 15.1993V15.1993C6.89388 16.2683 8.68978 16.2683 9.86573 15.1993L11.9168 13.3346" stroke="#F97171" strokeLinecap="round" />
    </svg>
  );
};

LinkIcon.defaultProps = {
  className: '',
  width: 22,
  height: 20,
};

export default LinkIcon;
